import React from "react";
import Home from "./pages/Home";

export default function MobileApp() {
	return <Home mobile />;
}
